import { ERegExpTypes } from 'constants/RegExpTypes';
import differenceInYears from 'date-fns/differenceInYears';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

const useCreateAccountFormSchema = () => {
  const { t } = useTranslation();
  const schemaIndividual = yup.object({
    email: yup
      .string()
      .email(t('page.createAccount.validation.email.format'))
      .max(254, 'This field should have max 255 characters.')
      .required(t('page.createAccount.validation.email.required')),
    prefixPhoneNumberUniqueId: yup
      .string()
      .required(t('page.createAccount.validation.prefix.required')),
    phoneNumber: yup
      .string()
      .required(t('page.createAccount.validation.phone.required'))
      .matches(
        new RegExp(ERegExpTypes.onlyDigits),
        t('page.createAccount.validation.phone.valueIsNotCorrect'),
      )
      .max(
        15,
        t('page.createAccount.validation.phone.maxNumberCharacters').replace('{0}', '15'),
      )
      .min(5, t('page.createAccount.validation.phone.minNumberCharacters').replace('{0}', '5'))
      .trim(),
    dateOfBirth: yup
      .string()
      .required(t('page.createAccount.validation.birth.required'))
      .test(
        'birth',
        t('page.createAccount.validation.birth.years'),
        (value) => differenceInYears(new Date(), new Date(value ?? 0)) >= 18,
      ),
    termsAndConditions: yup
      .boolean()
      .oneOf([true], t('page.createAccount.validation.termsAndConditions.required')),
  });

  const schemaCommercialOrganisation = yup.object({
    email: yup
      .string()
      .email(t('page.createAccount.validation.email.format'))
      .max(254, 'This field should have max 255 characters.')
      .required(t('page.createAccount.validation.email.required')),
    phoneNumber: yup
      .string()
      .required(t('page.createAccount.validation.phone.required'))
      .matches(
        new RegExp(ERegExpTypes.onlyDigits),
        t('page.createAccount.validation.phone.valueIsNotCorrect'),
      )
      .max(
        15,
        t('page.createAccount.validation.phone.maxNumberCharacters').replace('{0}', '15'),
      )
      .min(5, t('page.createAccount.validation.phone.minNumberCharacters').replace('{0}', '5'))
      .trim(),
  });

  return { schemaIndividual, schemaCommercialOrganisation };
};

export default useCreateAccountFormSchema;
